import Collection from '../../utils/Collection';

import { CLEAR_STUDENT_DATA } from '../../actions/student';

import {
  FETCH_PRONUNCIATION_STATUSES_SENT,
  FETCH_PRONUNCIATION_STATUSES_SUCCEEDED,
  UPDATE_PRONUNCIATION_STATUSES_SENT,
  UPDATE_PRONUNCIATION_STATUSES_SUCCEEDED,
  UPDATE_PRONUNCIATION_STATUSES_FAILED,
} from '../../actions/pronunciation';

const initialState = {
  statuses: [],
  loading: false,
  mutating: false,
};

export default function studentPronunciationReducer(
  state = initialState,
  action,
) {
  const { payload, type } = action;
  switch (type) {
    case CLEAR_STUDENT_DATA:
      return initialState;
    case FETCH_PRONUNCIATION_STATUSES_SENT:
      return {
        ...state,
        loading: true,
      };
    case FETCH_PRONUNCIATION_STATUSES_SUCCEEDED:
      return {
        ...state,
        statuses: Collection.reset(
          state.statuses,
          payload.pronunciation_statuses,
        ),
        loading: false,
      };
    case UPDATE_PRONUNCIATION_STATUSES_SENT:
      return {
        ...state,
        mutating: true,
      };
    case UPDATE_PRONUNCIATION_STATUSES_SUCCEEDED:
      return {
        ...state,
        mutating: false,
        statuses: payload.statuses,
      };
    case UPDATE_PRONUNCIATION_STATUSES_FAILED:
      return {
        ...state,
        mutating: false,
      };
    default:
      return state;
  }
}
